import React from 'react';

interface GridIconProps {
  size: number;
  color?: string;
  filledQuadrants?: number[]; // Array of quadrants to fill (1-4)
  fillColors?: string[]; // Colors for each quadrant
}

const GridIcon: React.FC<GridIconProps> = ({ 
  size, 
  color = '#2c3e50', 
  filledQuadrants = [1, 2, 3, 4], 
  fillColors = ['#2c3e50', '#2c3e50', '#2c3e50', '#2c3e50'] 
}) => {
  const strokeWidth = 4;
  const gap = 8; // Smaller gap to account for stroke width
  const squareSize = (size - gap - strokeWidth) / 2; // Account for stroke width

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} xmlns="http://www.w3.org/2000/svg">
      {/* Top-left square (Quadrant 2) */}
      {filledQuadrants.includes(2) && (
        <rect
          x={strokeWidth / 2}
          y={strokeWidth / 2}
          width={squareSize}
          height={squareSize}
          fill="none"
          stroke={fillColors[1] || color}
          strokeWidth={strokeWidth}
          rx={2}
          ry={2}
        />
      )}
      
      {/* Top-right square (Quadrant 1) */}
      {filledQuadrants.includes(1) && (
        <rect
          x={squareSize + gap + strokeWidth / 2}
          y={strokeWidth / 2}
          width={squareSize}
          height={squareSize}
          fill="none"
          stroke={fillColors[0] || color}
          strokeWidth={strokeWidth}
          rx={2}
          ry={2}
        />
      )}
      
      {/* Bottom-left square (Quadrant 3) */}
      {filledQuadrants.includes(3) && (
        <rect
          x={strokeWidth / 2}
          y={squareSize + gap + strokeWidth / 2}
          width={squareSize}
          height={squareSize}
          fill="none"
          stroke={fillColors[2] || color}
          strokeWidth={strokeWidth}
          rx={2}
          ry={2}
        />
      )}
      
      {/* Bottom-right square (Quadrant 4) */}
      {filledQuadrants.includes(4) && (
        <rect
          x={squareSize + gap + strokeWidth / 2}
          y={squareSize + gap + strokeWidth / 2}
          width={squareSize}
          height={squareSize}
          fill="none"
          stroke={fillColors[3] || color}
          strokeWidth={strokeWidth}
          rx={2}
          ry={2}
        />
      )}
    </svg>
  );
};

export default GridIcon; 